<template>
	<div class="catalog">
		<!-- 无章节目录	-->
		<div class="no-catalog" v-if="courseDetail.isChapter === 0">
			<div class="catalog-item" v-for="(item,index) in courseDetail.contentList" :key="item.id" :class="{'catalog-active': item.isChoose}" @click="changeChoose(item.id)">
				<div class="catalog-top">
					<div class="top-idx">
						<!-- 如果前面单数就加个0	-->
						<span v-if="index+1<10">0{{ index + 1 }}</span>
						<span v-else>{{ index + 1 }}</span>
					</div>
					<div class="mark"></div>
					<div class="name van-ellipsis">{{ item.name }}</div>
					<div class="try-mark" v-if="item.trySet === 1 || item.trySet === 2">试看</div>
				</div>
				<div class="catalog-bottom">
					<img :src="typePicArr[item.type]" alt="">
					<span>{{ typeArr[item.type] }}</span>
					<span class="bottom-time">{{ item.timeString }}</span>
				</div>
				<WxOpenTag ref="wxopentag" v-if="trainId" :extinfo="'CFClass/detail?hideNativeNav=1&courseId='+ courseDetail.id + '&trainId=' + trainId" />
				<WxOpenTag v-else ref="wxopentag" :extinfo="'CFClass/detail?hideNativeNav=1&courseId='+ courseDetail.id" />
			</div>
		</div>
		<!-- 有章节目录	-->
		<div class="have-catalog" v-else-if="courseDetail.isChapter === 1">
			<div class="have-header" @click="openChoose">
				<span>选择章节</span>
				<van-icon name="play" size="18px" color="#777777" />
			</div>
			<div class="have-item" v-for="item in courseDetail.chapterList" :key="item.id" :id="`phase${item.id}`">
				<template v-if="courseDetail.canModified === 1">
					<div class="have-title van-ellipsis">{{ item.name }}</div>
					<!-- 不是特殊课程	-->
					<div class="no-catalog" >
					<div class="catalog-item" v-for="(itm,idx) in item.contentList" :key="itm.id" :class="{'catalog-active': itm.isChoose}" @click="changeChoose(itm.id)">
						<div class="catalog-top">
							<div class="top-idx">
								<!-- 如果前面单数就加个0	-->
								<span v-if="idx+1<10">0{{ idx + 1 }}</span>
								<span v-else>{{ idx + 1 }}</span>
							</div>
							<div class="mark"></div>
							<div class="name van-ellipsis">{{ itm.name }}</div>
							<div class="try-mark" v-if="itm.trySet === 1 || itm.trySet === 2">试看</div>
						</div>
						<div class="catalog-bottom">
							<img :src="typePicArr[itm.type]" alt="">
							<span>{{ typeArr[itm.type] }}</span>
							<span class="bottom-time">{{ itm.timeString }}</span>
						</div>
						<WxOpenTag ref="wxopentag" v-if="trainId" :extinfo="'CFClass/detail?hideNativeNav=1&courseId='+ courseDetail.id + '&trainId=' + trainId" />
						<WxOpenTag v-else ref="wxopentag" :extinfo="'CFClass/detail?hideNativeNav=1&courseId='+ courseDetail.id" />
					</div>
				</div>
				</template>
				<!-- 是特殊课程	-->
				<template v-else-if="courseDetail.canModified === 0">
					<div class="have-item">
						<div class="have-title van-ellipsis">{{ item.name }}</div>
						<!-- 如果有小节	-->
						<template v-if="item.unitList && item.unitList.length > 0">
							<div class="nodule" v-for="itm in item.unitList" :key="itm.id" :id="`phase${itm.id}`">
								<div class="nodule-name">{{ itm.name }}</div>
								<div class="no-catalog" >
									<div class="catalog-item" v-for="(t,i) in itm.contentList" :key="t.id" :class="{'catalog-active': t.isChoose}" @click="changeChoose(t.id)">
										<div class="catalog-top">
											<div class="top-idx">
												<!-- 如果前面单数就加个0	-->
												<span v-if="i+1<10">0{{ i + 1 }}</span>
												<span v-else>{{ i + 1 }}</span>
											</div>
											<div class="mark"></div>
											<div class="name van-ellipsis">{{ t.name }}</div>
											<div class="try-mark" v-if="t.trySet === 1 || t.trySet === 2">试看</div>
										</div>
										<div class="catalog-bottom">
											<img :src="typePicArr[t.type]" alt="">
											<span>{{ typeArr[t.type] }}</span>
											<span class="bottom-time">{{ t.timeString }}</span>
										</div>
										<WxOpenTag ref="wxopentag" v-if="trainId" :extinfo="'CFClass/detail?hideNativeNav=1&courseId='+ courseDetail.id + '&trainId=' + trainId" />
										<WxOpenTag v-else ref="wxopentag" :extinfo="'CFClass/detail?hideNativeNav=1&courseId='+ courseDetail.id" />
									</div>
								</div>
							</div>
						</template>
						<template v-else-if="item.contentList">
							<!-- 不是特殊课程	-->
							<div class="no-catalog" >
								<div class="catalog-item" v-for="(itm,idx) in item.contentList" :key="itm.id" :class="{'catalog-active': itm.isChoose}" @click="changeChoose(itm.id)">
									<div class="catalog-top">
										<div class="top-idx">
											<!-- 如果前面单数就加个0	-->
											<span v-if="idx+1<10">0{{ idx + 1 }}</span>
											<span v-else>{{ idx + 1 }}</span>
										</div>
										<div class="mark"></div>
										<div class="name van-ellipsis">{{ itm.name }}</div>
										<div class="try-mark" v-if="itm.trySet === 1 || itm.trySet === 2">试看</div>
									</div>
									<div class="catalog-bottom">
										<img :src="typePicArr[itm.type]" alt="">
										<span>{{ typeArr[itm.type] }}</span>
										<span class="bottom-time">{{ itm.timeString }}</span>
									</div>
									<WxOpenTag ref="wxopentag" v-if="trainId" :extinfo="'CFClass/detail?hideNativeNav=1&courseId='+ courseDetail.id + '&trainId=' + trainId" />
									<WxOpenTag v-else ref="wxopentag" :extinfo="'CFClass/detail?hideNativeNav=1&courseId='+ courseDetail.id" />
								</div>
							</div>
						</template>
					</div>
				</template>
			</div>
		</div>
		<van-action-sheet v-model="chooseShow">
			<div class="choose">
				<div class="choose-title" @click="chooseShow=false">
					<span>选择章节</span>
					<van-icon name="play" size="18px" color="#777777" />
				</div>
				<template v-if="courseDetail.canModified === 1">
					<div class="choose-list">
						<div class="choose-item van-ellipsis" v-for="item in courseDetail.chapterList" :key="item.id" @click="goToChooseItem(item.id)">
							{{ item.name }}
						</div>
					</div>
				</template>
				<div class="unit-box" v-else-if="courseDetail.canModified === 0">
					<div class="unit-list" v-for="item in courseDetail.chapterList" :key="item.id">
						<div class="list-title" @click="goToChooseItem(item.id)">{{ item.name }}</div>
						<template>
							<div class="unit-item van-ellipsis" v-for="itm in item.unitList" :key="itm.id" @click="goToChooseItem(itm.id)">
								{{ itm.name }}
							</div>
						</template>
					</div>
				</div>
			</div>
		</van-action-sheet>
	</div>
</template>
<script>
import TestPic from '@/assets/image/learning/test.png'; // 默认图片
import Video from '@/assets/image/learning/video.png'; // 视频
import Word from '@/assets/image/learning/word.png'; // 文档
import Pic from '@/assets/image/learning/pic.png'; // 图片
import Audio from '@/assets/image/learning/audio.png'; // 音频
import Exam from '@/assets/image/learning/exam.png'; // 考试
import Graphic from '@/assets/image/learning/graphic.png'; // 图文课
import Link from '@/assets/image/learning/link.png';
import WxOpenTag from "@/components/WxOpenTag.vue"; // 链接

export default {
	name: "CourseCatalog",
	components: { WxOpenTag },
	data() {
		return {
			courseDetail: {},
			CourseDefault: TestPic,
			typeArr: ['视频', '文档', '图片', '音频', '考试', "图文课", "链接"],
			typePicArr: [Video, Word, Pic, Audio, Exam, Graphic, Link],
			chooseShow: false,
		};
	},
	props: {
		// 课程目录
		courseInfo: {
			type: Object,
			default: () => {
			},
		},
		trainId: {
			default: "",
		},
	},
	created() {
		this.getCourseDetail()
	},
	methods: {
		getCourseDetail() {
			this.courseDetail = JSON.parse(JSON.stringify(this.courseInfo))
			// 无章节
			if (this.courseDetail.isChapter === 0 && this.courseDetail.commentCount > 0) {
				for (let i = 0; i < this.courseDetail.contentList.length; i++) {
					this.$set(this.courseDetail.contentList[i], 'isChoose', false)
				}
			} else if (this.courseDetail.isChapter === 1 && this.courseDetail.commentCount > 0) {
				// 判断是否是特殊课程
				if (this.courseDetail.canModified === 1) {
					// 有章节
					for (let i = 0; i < this.courseDetail.chapterList.length; i++) {
						for (let j = 0; j < this.courseDetail.chapterList[i].contentList.length; j++) {
							this.$set(this.courseDetail.chapterList[i].contentList[j], 'isChoose', false)
						}
					}
				}
			}
		},
		// 点击改变选中样式
		changeChoose(id){
			// 无章节
			if (this.courseDetail.isChapter === 0) {
				for (let i = 0; i < this.courseDetail.contentList.length; i++) {
					if (this.courseDetail.contentList[i].id === id) {
						this.$set(this.courseDetail.contentList[i], 'isChoose', !this.courseDetail.contentList[i].isChoose)
					} else {
						this.$set(this.courseDetail.contentList[i], 'isChoose', false)
					}
				}
			} else if (this.courseDetail.isChapter === 1) {
				// 判断是否是特殊课程
				if (this.courseDetail.canModified === 1) {
					// 有章节
					for (let i = 0; i < this.courseDetail.chapterList.length; i++) {
						for (let j = 0; j < this.courseDetail.chapterList[i].contentList.length; j++) {
							if (this.courseDetail.chapterList[i].contentList[j].id === id) {
								this.$set(this.courseDetail.chapterList[i].contentList[j], 'isChoose', !this.courseDetail.chapterList[i].contentList[j].isChoose)
							} else {
								this.$set(this.courseDetail.chapterList[i].contentList[j], 'isChoose', false)
							}
						}
					}
				} else if(this.courseDetail.canModified === 0){
					// 有章节
					for (let i = 0; i < this.courseDetail.chapterList.length; i++) {
						if (this.courseDetail.chapterList[i].unitList && this.courseDetail.chapterList[i].unitList.length > 0) {
							for (let j = 0; j < this.courseDetail.chapterList[i].unitList.length; j++) {
								for (let k = 0; k < this.courseDetail.chapterList[i].unitList[j].contentList.length; k++) {
									if (this.courseDetail.chapterList[i].unitList[j].contentList[k].id === id) {
										this.$set(this.courseDetail.chapterList[i].unitList[j].contentList[k], 'isChoose', !this.courseDetail.chapterList[i].unitList[j].contentList[k].isChoose)
									} else {
										this.$set(this.courseDetail.chapterList[i].unitList[j].contentList[k], 'isChoose', false)
									}
								}
							}
						} else {
							for (let j = 0; j < this.courseDetail.chapterList[i].contentList.length; j++) {
								if (this.courseDetail.chapterList[i].contentList[j].id === id) {
									this.$set(this.courseDetail.chapterList[i].contentList[j], 'isChoose', !this.courseDetail.chapterList[i].contentList[j].isChoose)
								} else {
									this.$set(this.courseDetail.chapterList[i].contentList[j], 'isChoose', false)
								}
							}
						}
					}
				}
			}
		},
		// 打开选择章节
		openChoose() {
			this.chooseShow = true;
		},
		goToChooseItem(id) {
			this.chooseShow = false;
			// 同时切换到对应的阶段
			this.$nextTick(()=>{
				// 计算phase${ id }距离顶部的高度
				let element = document.getElementById(`phase${ id }`); // 替换为你的元素ID
				let rect = element.getBoundingClientRect();
				let distanceToTop = rect.top + window.scrollY - 100;
				window.scrollTo({
					top: distanceToTop,
					behavior: 'smooth' // 平滑滚动
				});
			})
		},
	}
};
</script>
<style scoped lang="css">
* {
	box-sizing: border-box;
}

.catalog {
	display: flex;
	flex-direction: column;
	padding: 2px 15px 15px;
	background-color: #fff;
}

.no-catalog {
	flex: 1;
	display: flex;
	flex-direction: column;
}

.no-catalog .catalog-item {
	position: relative;
	width: 100%;
	background: #F6F6F6;
	border-radius: 4px;
	margin-top: 10px;
	padding: 15px 10px 12px 18px;
	border: 1px solid transparent;
}

.catalog-item .catalog-top {
	display: flex;
	align-items: center;
	margin-bottom: 5px;
}

.catalog-top .top-idx {
	font-weight: 600;
	font-size: 14px;
	color: #333333;
}

.catalog-top .mark {
	width: 1px;
	height: 13px;
	background: #D8D8D8;
	margin: 0 8px;
}

.catalog-top .name {
	flex: 1;
	font-weight: 600;
	font-size: 14px;
	color: #333333;
	line-height: 20px;
}

.catalog-top .try-mark {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 39px;
	height: 20px;
	background: #FFDBDA;
	border-radius: 10px;
	font-size: 12px;
	color: #F53F3F;
}

.catalog-bottom {
	display: flex;
	align-items: flex-start;
}

.catalog-bottom img {
	width: 20px;
	height: 20px;
	margin-right: 12px;
}

.catalog-bottom span {
	font-weight: 400;
	font-size: 13px;
	color: #777777;
}
.no-catalog .catalog-active{
	background: #FFF6F6;
	border: 1px solid #E6001F;
}
.catalog-active .catalog-top .top-idx{
	color: #F7443F;
}
.catalog-active .catalog-top .name{
	color: #F7443F;
}
.catalog-active .catalog-top .mark{
	background: #F7443F;
}
.catalog-active .catalog-bottom span{
	color: #F7443F;
}

.catalog-bottom .bottom-time {
	margin-left: 10px;
}
.have-catalog .have-header{
	position: sticky;
	top: 45px;
	display: flex;
	align-items: center;
	z-index: 1100;
	background-color: #fff;
	padding: 14px 0;
}
.have-catalog .have-header span{
	font-size: 15px;
	color: #333333;
	margin-right: 3px;
}
.have-catalog .have-header .van-icon{
	transform: rotate(90deg);
}
.have-catalog .have-item{
	margin-bottom: 15px;
}
.have-catalog .have-item .have-title{
	font-weight: 600;
	font-size: 15px;
	color: #333333;
	padding-bottom: 10px;
	border-bottom: 1px solid #F0F0F0;
}
.choose{
	padding-bottom: 80px;
	max-height: 80vh;
}
.choose .choose-title{
	display: flex;
	align-items: center;
	height: 60px;
	border-bottom: 1px solid #F0F0F0;
	padding-left: 20px;
}
.choose .choose-title span{
	font-weight: 600;
	font-size: 17px;
	color: #555555;
}
.choose .choose-title .van-icon{
	transform: rotate(-90deg);
	margin-left: 4px;
}
.choose-list{
	padding: 0 15px;
}
.choose .choose-item{
	padding: 15px 2px 11px;
	border-bottom: 1px solid #F0F0F0;
}
.nodule-name{
	position: relative;
	font-weight: 600;
	font-size: 14px;
	color: #333333;
	margin: 10px 0 0;
	padding-left: 12px;
}
.nodule-name::before{
	position: absolute;
	top: 50%;
	left: 2px;
	transform: translateY(-50%);
	content: '';
	display: block;
	width: 5px;
	height: 5px;
	background: #F7443F;
	border-radius: 3px;
}
.unit-box{
	padding: 15px;
}
.unit-list{
	margin-bottom: 15px;
	border-bottom: 1px solid #F0F0F0;
	padding-bottom: 12px;
}
.unit-list .list-title{
	font-weight: 600;
	font-size: 15px;
	color: #333333;
}
.unit-list .unit-item{
	position: relative;
	padding-left: 15px;
	font-weight: 600;
	font-size: 14px;
	color: #333333;
	margin-top: 10px;
}
.unit-item::before{
	position: absolute;
	top: 50%;
	left: 2px;
	transform: translateY(-50%);
	content: '';
	display: block;
	width: 5px;
	height: 5px;
	background: #F7443F;
	border-radius: 3px;
}
</style>